// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/f4a2ec79/" + chunkId + "." + __webpack_require__.h() + ".vf4a2ec79.js";
};